import { GlobalSearchQuery } from "types";

export type SearchCompany =
  GlobalSearchQuery["searchCompanies"]["list"][number];
export type SearchEmployee =
  GlobalSearchQuery["searchEmployees"]["list"][number];
export type SearchItem = SearchCompany | SearchEmployee;

export const isSearchEmployee = (item: SearchItem): item is SearchEmployee => {
  return "firstName" in item;
};

export const isSearchCompany = (item: SearchItem): item is SearchCompany => {
  return !isSearchEmployee(item);
};

export type GlobalSearchProviderProps = {
  open: boolean;
  onDismiss: () => void;
};

export type GlobalSearchContextType = {
  query: string;
  setQuery: (query: string) => void;
  companies: SearchCompany[];
  employees: SearchEmployee[];
  loading: boolean;
  recentSearches: SearchItem[];
  handleItemClick: (item: SearchItem) => void;
  clearRecentSearches: () => void;
} & GlobalSearchProviderProps;
